import { render, staticRenderFns } from "./auDelivery.vue?vue&type=template&id=5695a996&scoped=true"
import script from "./auDelivery.vue?vue&type=script&lang=js"
export * from "./auDelivery.vue?vue&type=script&lang=js"
import style0 from "./auDelivery.vue?vue&type=style&index=0&id=5695a996&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695a996",
  null
  
)

export default component.exports